<template>
  <div class="wrap">
    <div class="modal" v-if="isModalOpen">
      <div class="modal-body">
        <p>遊戲結束</p>
        <p>你的分數為</p>
        <p class="score">{{ score }}</p>
        <p></p>
        <!-- <p class="content"  v-if="!isCardShow">未達成{{targetScore}}分<br></p>
        <p class="content" v-if="isCardShow">恭喜達成{{targetScore}}分！<br></p> -->
        <!-- <button v-if="isCardShow" @click="$emit('update:view', 'Card')">開啟卡片</button> -->
        <button class="reset" @click="reset">再試一次</button>
        <button @click="$emit('update:view', 'Home')">回首頁</button>
      </div>
    </div>
    <div class="bar">
      <div class="time"><p>時間：<span>{{ time }}</span></p></div>
      <div class="score">分數：<span>{{ score }}</span></div>
    </div>
    <div class="card-group">
      <div class="card"
      v-for="(item, i) in randomCardPattern"
      :key="i"
      :class="{active : selectedCard.indexOf(i) > -1 || correctCard.indexOf(i) > -1}"
      @click="selectCard(i)"
      >
        <div class="card-front"></div>
        <div class="card-back">
          <span class="material-icons">{{ item }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      time: 90,
      timer: null,
      score: 2000,
      pattern: ['favorite', 'celebration', 'cake', 'local_florist', 'wine_bar', 'thumb_up'],
      randomCardPattern: [],
      selectedCard: [],
      cardTimer: null,
      correctCard: [],
      isModalOpen: false,
      isCardShow: false,
      targetScore: 1600,
    };
  },
  mounted() {
    this.timer = setInterval(() => {
      if (this.time > 0) {
        this.time -= 1;
        this.score -= 10;
      } else {
        this.isModalOpen = true;
        if (this.score >= this.targetScore) {
          this.isCardShow = true;
        }
        clearInterval(this.timer);
      }
    }, 1000);
    this.randomCardPattern = [...this.pattern, ...this.pattern];
    const len = this.pattern.length;
    let i = 0;
    while (i < len) {
      const randomI = Math.floor(Math.random() * ((len - 1) - 1));
      const temp = this.randomCardPattern[i];
      this.randomCardPattern[i] = this.randomCardPattern[randomI];
      this.randomCardPattern[randomI] = temp;
      i += 1;
    }
  },
  methods: {
    selectCard(i) {
      const vm = this;
      if (vm.correctCard.indexOf(i) > -1 || vm.selectedCard[0] === i) {
        return;
      }
      if (vm.selectedCard.length > 1) {
        vm.selectedCard.splice(0, 1);
      }
      vm.selectedCard.push(i);
      if (vm.selectedCard.length === 2) {
        if (vm.randomCardPattern[vm.selectedCard[0]]
        !== vm.randomCardPattern[vm.selectedCard[1]]) {
          vm.score -= 50;
        } else {
          vm.score += 100;
          vm.correctCard.push(vm.selectedCard[0]);
          vm.correctCard.push(vm.selectedCard[1]);
          vm.selectedCard = [];
          if (vm.randomCardPattern.length === vm.correctCard.length) {
            clearInterval(vm.timer);
            vm.isModalOpen = true;
            if (vm.score >= vm.targetScore) {
              vm.isCardShow = true;
            } else {
              vm.isCardShow = false;
            }
            if (vm.score > localStorage.getItem('score')) {
              localStorage.setItem('score', vm.score);
            }
          }
        }
      }
      if (vm.cardTimer) {
        clearTimeout(vm.cardTimer);
      }
      vm.cardTimer = setTimeout(() => {
        console.log('重置');
        vm.selectedCard = [];
      }, 1000);
    },
    reset() {
      this.time = 90;
      this.selectedCard = [];
      this.correctCard = [];
      this.score = 2000;
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = setInterval(() => {
        if (this.time > 0) {
          this.time -= 1;
          this.score -= 10;
        } else {
          this.isModalOpen = true;
          if (this.score >= this.targetScore) {
            this.isCardShow = true;
          }
          clearInterval(this.timer);
        }
      }, 1000);
      this.randomCardPattern = [...this.pattern, ...this.pattern];
      const len = this.pattern.length;
      let i = 0;
      while (i < len) {
        const randomI = Math.floor(Math.random() * ((len - 1) - 1));
        const temp = this.randomCardPattern[i];
        this.randomCardPattern[i] = this.randomCardPattern[randomI];
        this.randomCardPattern[randomI] = temp;
        i += 1;
      }
      this.isModalOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  .bar {
    display: flex;
    justify-content: space-between;
    width: calc(100% - 56px);
    margin-bottom: 12px;
    position: absolute;
    top: 20px;
  }
  .time, .score {
    p, span {
      margin: 0;
    }
    border-radius: 999px;
    border: 0;
    background: #535353;
    height: 44px;
    color: #FBC150;
    font-size: 24px;
    font-weight: bold;
    transition: all .3s ease-out;
    cursor: pointer;
    margin-bottom: 0px;
    line-height: 44px;
    display: flex;
    padding: 0 14px;
  }
  .score {
    color: #535353;
    background: #FBC150;
  }
  height: calc(100vh - 50px);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 25px 16px;
  justify-content: center;
  position: relative;
}
.card-group {
  .card {
    &.active {
      .card-front {
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
      }
      transform: rotateY(180deg);
    }
    .card-front {
      background: radial-gradient(199.62% 135.53% at 95.56% 93.75%, #FBC150 0%, #FFE0C4 100%);
      z-index: 2;
      transform: rotateY(0deg);
      -webkit-backface-visibility: visible;
      backface-visibility: visible;
    }
    .card-back {
      span {
        font-size: 36px;
        color: #FBC150;
      }
      background: #535353;
      z-index: 1;
      transform: rotateY(180deg);
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .card-front, .card-back {
      width: 100%;
      border-radius: 10px;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
    }
    width: calc(33% - 24px);
    height: 115px;
    margin: 12px;
    position: relative;
    -webkit-transform-style: preserve-3d;
    transform-style: preserve-3d;
    cursor: pointer;
    transition: all .3s ease-out;
    -webkit-transition: all .3s ease-out;
  }
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin-top: 60px;
}
.modal {
  .modal-body {
    p {
      color: #535353;
      font-size: 28px;
      font-weight: bold;
      margin: 0;
      text-align: center;
    }
    .score {
      color: red;
      display: inline-block;
      margin-top: 20px;
      font-size: 32px;
    }
    button {
      height: 52px;
      width: 145px;
      background-color: #fff;
      color: #535353;
      font-size: 24px;
      font-weight: bold;
      border-radius: 999px;
      border: 0;
      margin-top: 32px;
      margin-right: 6px;
      margin-left: 6px;
    }
    .reset {
      background-color: #535353;
      color: #fff;
    }
    .content {
      margin-top: 20px;
    }
    width: 319px;
    border-radius: 10px;
    background-color: #FBC150;
    padding: 20px;
  }
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background-color: rgba(27, 27, 27, 0.507);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
}
</style>
